export default "__VITE_ASSET__fd36e2fa__"